import { BadgeAliment } from './types.utils';

const BADGE_BASE = {
    align: BadgeAliment.MIDDLE,
    color: 'grey-lighter',
    textColor: 'grey-dark',
    style: 'border: 1px solid #d9e0ed;'
};

const BADGE_ROUNDED_BASE = {
    rounded: true
};

export const BADGE_SM = Object.assign({}, BADGE_BASE, { class: 'text-caption q-badge-sm' });

export const BADGE_MD = Object.assign({}, BADGE_BASE, { class: 'text-body2 q-badge-md' });

export const BADGE_LG = Object.assign({}, BADGE_BASE, { class: 'text-body2 q-badge-lg' });

export const BADGE_ROUNDED_SM = Object.assign({}, BADGE_SM, BADGE_ROUNDED_BASE);

export const BADGE_ROUNDED_MD = Object.assign({}, BADGE_MD, BADGE_ROUNDED_BASE);

export const BADGE_ROUNDED_LG = Object.assign({}, BADGE_LG, BADGE_ROUNDED_BASE);

export const BADGE_PRIMARY_MD = Object.assign({}, BADGE_BASE, { textColor: 'white', color: 'primary', class: 'text-body2 text-weight-bold q-badge-md' });

export const BADGE_PRIMARY = Object.assign({}, BADGE_BASE, { textColor: 'white', color: 'primary', class: 'text-body2 text-weight-bold q-badge-lg' });
